import Axios from "axios";
import {config} from "@/config";

Axios.defaults.baseURL = config.apiUrl;
Axios.defaults.headers.common['Content-Type'] = 'application/json';

export default {
    namespaced: true,
    state: {
        data: [],
        marketplaces: [],  // Stores all marketplaces
        productMarketplaces: [], // Stores product marketplaces
    },
    getters: {
        DATA: state => {
            return state.data;
        },
        MARKETPLACES: state => state.marketplaces,
        PRODUCT_MARKETPLACES: state => state.productMarketplaces,
    },
    mutations: {
        DATA: (state, payload) => {
            return state.data = payload;
        },
        SET_MARKETPLACES: (state, payload) => state.marketplaces = payload,
        SET_PRODUCT_MARKETPLACES: (state, payload) => state.productMarketplaces = payload,
    },
    actions: {
        GET_DATA: async ({commit}, payload) => {
            payload.th.showOverlay = true;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/product/' + payload.th.productId,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('DATA', responseData.data);
                    payload.th.initValue()
                    payload.th.isReady = true
                },
                getResponse: () => {
                    payload.th.showOverlay = false;
                },
            });
        },
        SAVE: async ({state}, payload) => {
            let formData = new FormData()
            for (let key in state.data) {
                if (payload.th.checkInField(key)) {
                    formData.append(key, state.data[key])
                }
            }
            //famaga photo
            for (let key in state.data.newPhotos) {
                if (state.data.newPhotos[key] && state.data.newPhotos[key] != '') {
                    formData.append('newPhoto_'+ key, state.data.newPhotos[key])
                }
            }
            //product photo
            for (let key in state.data.newProductPhotos ) {
                if (state.data.newProductPhotos[key] && state.data.newProductPhotos[key] != '') {
                    formData.append('newProductPhoto_'+ key, state.data.newProductPhotos[key])
                }
            }
            //documents 1-4
            for (let i = 1; i <= 4; i ++) {
                for (let key in state.data['newDocument'+ i] ) {
                    if (state.data['newDocument'+ i][key] && state.data['newDocument'+ i][key] != '') {
                        formData.append('newDocument_'+ i +'_'+ key, state.data['newDocument'+ i][key])
                    }
                }
            }

            payload.th.showOverlay ++
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/goods-edit/' + payload.th.productId,
                parameter: formData,
                config: {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                },
                th: payload.th,
                showSuccessMessage: true,
                getSuccessResponse: (responseData) => {
                    if (responseData.status === "success") {
                        payload.th.isReady = false
                        payload.th.GET_DATA({th: payload.th})
                    }
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                }
            });
        },

        DELETE: async ({state}, payload) => {
            console.log(state)
            payload.th.showOverlay ++
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/goods-delete/' + payload.th.productId,
                parameter: [],
                th: payload.th,
                showSuccessMessage: true,
                getSuccessResponse: (responseData) => {
                    if (responseData.status === "success") {
                        payload.th.$router.push({name: 'product'})
                    }
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                }
            });
        },
        // Fetch all marketplaces
        GET_MARKETPLACES: async ({commit}, payload) => {
            payload.th.showOverlay = true;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/marketplace',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('SET_MARKETPLACES', responseData.data);
                },
                getResponse: () => {
                    payload.th.showOverlay = false;
                },
            });
        },

        // Fetch product marketplaces for a specific product
        GET_PRODUCT_MARKETPLACES: async ({commit}, payload) => {
            payload.th.showOverlay = true;
            await payload.th.$store.dispatch('SEND_GET', {
                url: `/product/${payload.th.productId}/marketplace`,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('SET_PRODUCT_MARKETPLACES', responseData.data);
                },
                getResponse: () => {
                    payload.th.showOverlay = false;
                },
            });
        },
        SAVE_PRODUCT_MARKETPLACE: async (context, {th, productId, marketplaceId, data}) => {
            if (!productId || !marketplaceId) {
                throw new Error("Both productId and marketplaceId are required.");
            }

            th.showOverlay++;
            try {
                await th.$store.dispatch('SEND_POST', {
                    url: `/product/${productId}/marketplace/${marketplaceId}`,
                    parameter: JSON.stringify(data),
                    config: {
                        headers: {
                            'Content-Type':'application/json',
                        },
                    },
                    th: th,
                    showSuccessMessage: true,
                    getSuccessResponse: (responseData) => {
                        if (responseData.status === "success") {
                            th.isReady = false;
                            th.GET_DATA({th});
                        }
                    },
                    getHandleError: (errorInfo) => {
                        console.error('Custom error handler for SAVE_PRODUCT_MARKETPLACE:', errorInfo);
                        alert(`Failed to save marketplace: ${errorInfo || "Unknown error occurred"}`);
                    },
                    getResponse: () => {
                        th.showOverlay--;
                    },
                });
            } catch (error) {
                console.error(`Error in SAVE_PRODUCT_MARKETPLACE (${productId}, ${marketplaceId}):`, error);
                alert(`Error: ${error.message || "An unexpected error occurred. Please try again."}`);
            }
        },
    }
}